import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('basePath');
export const CDN_PATH = new InjectionToken<string>('cdnPath');
export const APP_INIT_PARAMS = new InjectionToken<ApplicationInitParams>('initParams');

export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}

export interface ApplicationInitParams {
  name: string;
  logoUrl: string;
}
export type apiResponseFormat = 'text/plain' | 'application/json' | 'text/json';